// material-ui
import { Container, Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

import brandMark from 'assets/images/zhilv-mark.svg';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const Footer = () => {
  const siteInfo = useSelector((state) => state.siteInfo);

  return (
    <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 72, py: 1 }}>
      <Box sx={{ textAlign: 'center' }}>
        {siteInfo.footer_html ? (
          <div className="custom-footer" dangerouslySetInnerHTML={{ __html: siteInfo.footer_html }}></div>
        ) : (
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.9}>
            <Box
              component="img"
              src={brandMark}
              alt="景景虹科技品牌标志"
              sx={{ width: 34, height: 30, display: 'block', flex: '0 0 auto' }}
            />
            <Box sx={{ textAlign: 'left' }}>
              <Typography sx={{ color: '#18221F', fontSize: 14, fontWeight: 800, lineHeight: 1.1, whiteSpace: 'nowrap' }}>
                景景虹科技
              </Typography>
              <Typography sx={{ color: '#66736E', fontSize: 10.5, lineHeight: 1.2, mt: 0.35, whiteSpace: 'nowrap' }}>
                上海景景虹科技有限公司
              </Typography>
            </Box>
          </Stack>
        )}
      </Box>
    </Container>
  );
};

export default Footer;
